import { IdeaIcon } from 'components/icons';
import { CardBackground } from 'components/ui';

export const ExploreSegments = () => {
  return (
    <CardBackground>
      <div className="w-full p-5 lg:p-10">
        <div className="w-16 h-16 px-5 py-3 border rounded-full border-segments-accent-color-2">
          <IdeaIcon />
        </div>
        <div className="mt-8">
          <p className="text-2xl leading-7">Explore Segments</p>
          <p className="mt-6 text-base text-black text-opacity-50">
            Segments helps you grow your business with data! Increase repeat
            revenue with our prebuilt segmentation and actionable insights.
          </p>
        </div>
        <div className="mt-6 aspect-w-16 aspect-h-9">
          <iframe
            src="https://www.youtube.com/embed/yf_m-WhwLp4"
            title="Segments demo video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </CardBackground>
  );
};
